enum MutationType {
  SET_SEARCH_QUERY = "search/SET_SEARCH_QUERY",
}

export default MutationType;
